/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from "react";
import PropTypes from "prop-types";

const Desktop = ({
	onHide, show, text, color, withOk, closable,
}) => {

	useEffect(() => {

		let autoClose;

		// eslint-disable-next-line no-unused-expressions
		if (closable) {

			autoClose = setTimeout(() => onHide(), 3000);

		}

		return (() => {

			clearTimeout(autoClose);

		});

	}, [show, closable]);

	return (
		<>
			<div className={`pdp-popup ${show ? "show" : ""}`}>
				<span className="text">
					{text}
				</span>
				{withOk && (
					<button type="button" onClick={() => onHide()} className="button">
						Oke
					</button>
				)}
			</div>
			<style>
				{`

					.pdp-popup {
						width: 600px;
						padding: 8px;
						position: fixed;
						top: -50px;
						left: 50%;
						z-index: 1999;
						transform: translate(-50%, -50%);
						display: flex;
						justify-content: space-between;
						color: #ffffff;
						background-color: ${color};
						opacity: 0;
						visibility: hidden;
						transition: all .3s ease;
					}

					.pdp-popup.show {
						top: 50px;
						opacity: 1;
						visibility: visible;
					}

					.pdp-popup button {
						
						font-size: 16px;
						padding: 0;
						background-color: transparent;
						background-repeat: no-repeat;
						border: none;
						cursor: pointer;
						overflow: hidden;
						outline: none;
						color: #ffffff;
					}

				`}
			</style>
		</>
	);

};

Desktop.propTypes = {
	show: PropTypes.bool.isRequired,
	text: PropTypes.string.isRequired,
	onHide: PropTypes.func.isRequired,
	color: PropTypes.string.isRequired,
	withOk: PropTypes.bool.isRequired,
	closable: PropTypes.bool.isRequired,
};

export default Desktop;
